// 서버가 layouts/_head.html.erb 에서 심어주는 `window.MailyI18n` (config/locales/spaces/js.*.yml 의 `js:` 트리)에서
// 문구를 꺼낸다. 사전이 없거나 키가 비어 있으면 fallback(기존 한국어 문구)을 그대로 쓴다.
//
//   import { t } from "@/utils/i18n";
//   button.innerText = t("pin.sending", "발송중..");
export function t(key, fallback = "") {
  const dict = (typeof window !== "undefined" && window.MailyI18n) || {};
  const value = key.split(".").reduce((node, part) => (node && typeof node === "object" ? node[part] : undefined), dict);
  return typeof value === "string" && value.length > 0 ? value : fallback;
}
